import { Injectable } from "@angular/core";
import { ApiService } from "../http/api.service";
import {
  ReferralCodeExistsResponse,
  ReferralCodeInfoResponse,
  ReferralCodeResponse,
  ReferralDiscountResponse,
  ReferralInfoResponse,
} from "../../shared/backend-api.types";
import { apiPath } from "../../shared/api-path.const";
import { Referral } from "./referral.interface";

@Injectable({
  providedIn: "root",
})
export class ReferralApiService {
  constructor(private readonly apiService: ApiService) {}

  public async referralCodeExists(referralCode: string): Promise<boolean> {
    const response = await this.apiService.sendGetRequest<ReferralCodeExistsResponse>(
      `${apiPath.referral}/code/${referralCode}/exists`,
      undefined,
    );
    return response.exists;
  }

  public async getReferralByReferralCode(referralCode: string): Promise<ReferralCodeInfoResponse> {
    return this.apiService.sendGetRequest<ReferralCodeInfoResponse>(
      `${apiPath.referral}/code/${referralCode}`,
      undefined,
    );
  }

  public async getReferralByUserId(userId: string): Promise<Referral | undefined> {
    const response = await this.apiService.sendGetRequest<ReferralInfoResponse>(
      `${apiPath.referral}/user/${userId}`,
      undefined,
    );
    if (!response.referral) return undefined;
    const r = response.referral;
    return {
      id: r.referralId,
      userId: r.referrerUserId,
      referralPromoCode: r.referralPromoCode,
      createdAt: r.referredAt,
    };
  }

  public async getMyReferralCode(userId: string): Promise<string> {
    const response = await this.apiService.sendGetRequest<ReferralCodeResponse>(
      `${apiPath.referral}/user/${userId}/code`,
      undefined,
    );
    return response.referralPromoCode;
  }

  public async getDiscountToApply(referringUserId: string): Promise<number> {
    const response = await this.apiService.sendGetRequest<ReferralDiscountResponse>(
      `${apiPath.referral}/user/${referringUserId}/discount`,
      undefined,
    );
    return response.discountPercentage;
  }
}
